module.exports = __webpack_public_path__ + "static/me-69a705821e859aa568d361955c8c40f8.mp4";